import styles from "./LegalPage.module.css";

// Shared shell for legal / informational pages: Privacy Policy, Terms,
// Shipping, Affiliates, Contact. Each page passes a title, optional
// eyebrow, summary, and a list of sections. A section can be a body
// block, a definition list, or a list of links.
export default function LegalPage({
  eyebrow,
  title,
  updated,
  summary,
  sections = [],
  footer = null,
}) {
  return (
    <article className={styles.page}>
      <header className={styles.head}>
        {eyebrow && <span className={styles.eyebrow}>{eyebrow}</span>}
        <h1 className={styles.title}>{title}</h1>
        {updated && <div className={styles.updated}>Last updated: {updated}</div>}
        {summary && <p className={styles.summary}>{summary}</p>}
      </header>
      <div className={styles.body}>
        {sections.map((s, i) => (
          <section key={s.id || i} id={s.id} className={styles.section}>
            {s.title && <h2 className={styles.sectionTitle}>{s.title}</h2>}
            {s.body && <p className={styles.sectionBody}>{s.body}</p>}
            {s.list?.length > 0 && (
              <ul className={styles.list}>
                {s.list.map((it, j) => <li key={j}>{it}</li>)}
              </ul>
            )}
            {s.dl?.length > 0 && (
              <dl className={styles.dl}>
                {s.dl.map((row, j) => (
                  <div key={j}>
                    <dt>{row.label}</dt>
                    <dd>{row.value}</dd>
                  </div>
                ))}
              </dl>
            )}
            {s.links?.length > 0 && (
              <ul className={styles.links}>
                {s.links.map((l, j) => (
                  <li key={j}>
                    <a href={l.href} target={l.external ? "_blank" : undefined} rel={l.external ? "noopener noreferrer" : undefined}>
                      {l.label}
                    </a>
                    {l.note && <span className={styles.note}> — {l.note}</span>}
                  </li>
                ))}
              </ul>
            )}
          </section>
        ))}
      </div>
      {footer && <footer className={styles.foot}>{footer}</footer>}
    </article>
  );
}
